export const toTitleCase = (text: string) => {
  if (!text) {
    return '';
  }

  return text
    .toLowerCase()
    .split(/[^a-z0-9]/i)
    .filter((word) => word.length > 0)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};
